export default class VisualObject {
    public drawOverview(context: CanvasRenderingContext2D) {
    }

    public drawOutput(context: CanvasRenderingContext2D) {
    }
}
